import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import Helper from "./helper.js";

import.meta.glob([
    '../img/**',
    '../video/**'
], { eager: true });

class App {
    constructor() {
        this.init();
    }

    init() {
        // this.initStickyNavbar();
        this.initNavbarBackdrop();
        this.scrollIntoView();
        this.honeyForms();
        this.asyncForms();
        this.cookies();
        this.counter();
        this.referenceSlider();
        this.photoGridSlider();
        this.panelGridSlider();
        this.bannerVideoModal();
        this.visualBannerSlider();
    }

    initStickyNavbar() {
        const navbar = document.getElementById('main-navbar');

        const header = document.querySelector('header');

        if (navbar === null || header == null) {
            return false;
        }

        const scrolled = navbar.offsetHeight;

        const sticky = header.offsetHeight;

        window.addEventListener('scroll', () => {
            if (window.pageYOffset >= scrolled) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }

            if (window.pageYOffset >= sticky) {
                navbar.classList.add('sticky');
            } else {
                navbar.classList.remove('sticky');
            }
        });
    }

    initNavbarBackdrop() {
        const collapseEl = document.getElementById('main-navbar-collapse');

        if (!collapseEl) return;

        // Create backdrop element
        const backdrop = document.createElement('div');
        backdrop.classList.add('main-navbar__backdrop');
        document.body.appendChild(backdrop);

        collapseEl.addEventListener('show.bs.collapse', () => {
            backdrop.classList.add('main-navbar__backdrop--visible');
        });

        collapseEl.addEventListener('hide.bs.collapse', () => {
            backdrop.classList.remove('main-navbar__backdrop--visible');
        });

        // Close menu when backdrop is clicked
        backdrop.addEventListener('click', () => {
            bootstrap.Collapse.getInstance(collapseEl)?.hide();
        });
    }

    scrollIntoView() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                const targetId = this.getAttribute('href').slice(1); // remove the #

                const target = document.getElementById(targetId);

                if (target) {
                    e.preventDefault();

                    target.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

    honeyForms() {
        // Initialize honey pot for a single form
        const initHoneyForm = (form) => {
            // Skip if already initialized
            if (form.dataset.honeyInitialized === 'true') {
                return;
            }

            // Mark as initialized
            form.dataset.honeyInitialized = 'true';

            // Randomize delay between 4-6 seconds to be less predictable
            const delay = 4000 + Math.random() * 2000;

            setTimeout(() => {
                let buttonSubmit = form.querySelector('button[type="submit"]');

                if (buttonSubmit) {
                    // Restore original button text
                    const originalText = buttonSubmit.getAttribute('data-text');

                    if (originalText) {
                        buttonSubmit.innerHTML = originalText;
                        buttonSubmit.disabled = false;
                    }
                }

                let coffeeCup = form.querySelector('.coffee-cup');

                if (coffeeCup) {
                    // Fill the coffee cup
                    coffeeCup.value = 'filled';

                    // For Livewire-bound fields, trigger input event to sync with wire:model
                    if (coffeeCup.hasAttribute('wire:model') || coffeeCup.hasAttribute('wire:model.defer')) {
                        coffeeCup.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            }, delay);
        };

        // Initialize all existing honey forms
        document.querySelectorAll('.form--honey').forEach(form => {
            initHoneyForm(form);
        });

        // Watch for dynamically added forms
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    // Check if the added node is a form with honey class
                    if (node.nodeType === 1) {
                        if (node.classList && node.classList.contains('form--honey')) {
                            initHoneyForm(node);
                        }

                        // Also check for honey forms within the added node
                        if (node.querySelectorAll) {
                            node.querySelectorAll('.form--honey').forEach(form => {
                                initHoneyForm(form);
                            });
                        }
                    }
                });
            });
        });

        // Start observing the document for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        const initializeRecaptcha = () => {
            if (typeof grecaptcha === 'undefined') {
                return false;
            }

            document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
                if (recaptcha.dataset.initialized === 'true') {
                    return;
                }

                let widgetId = grecaptcha.render(recaptcha.id, {
                    'sitekey': recaptcha.dataset.sitekey
                });

                recaptcha.dataset.initialized = 'true';
                gRecaptchaWidgets.push(widgetId);
            });

            return true;
        };

        if (!initializeRecaptcha() && document.querySelector('.g-recaptcha-widget')) {
            const recaptchaInterval = setInterval(() => {
                if (initializeRecaptcha()) {
                    clearInterval(recaptchaInterval);
                }
            }, 100);
        }

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha === 'undefined') {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                grecaptcha.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert--' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookies-banner__options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
            .catch(error => {
                // Reject the promise
                return Promise.reject(error.statusText);
            });
        });
    }

    counter() {
        const counters = document.querySelectorAll('.stats__value');

        const formatNumber = (num) => {
            return num.toLocaleString('nl-NL'); // Formats as "4.000" using dot
        };

        const animateCount = (el, start, target) => {
            const duration = el.dataset.duration || 1500;

            const startTime = performance.now();

            const update = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const current = Math.floor(start + (target - start) * progress);

                el.textContent = formatNumber(current);

                if (progress < 1) {
                    requestAnimationFrame(update);
                }
            };

            requestAnimationFrame(update);
        };

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const el = entry.target;
                    const start = parseInt(el.dataset.start || 0, 10);
                    const target = parseInt(el.dataset.target, 10);

                    animateCount(el, start, target);

                    observer.unobserve(el); // Animate only once
                }
            });
        }, { threshold: 0.5 });

        counters.forEach(counter => {
            observer.observe(counter);
        });
    }

    referenceSlider() {
        document.querySelectorAll('.references__list').forEach(element => {
            const maximumSlidesPerView = Number(element.dataset.slidesPerView) || 6;
            const slideCount = element.querySelectorAll('.swiper-slide').length;

            new Swiper(element, {
                loop: slideCount > maximumSlidesPerView,
                autoplay: {
                    delay: 3000
                },
                breakpoints: {
                    0: {
                        slidesPerView: Math.min(2, maximumSlidesPerView)
                    },
                    325: {
                        slidesPerView: Math.min(3, maximumSlidesPerView)
                    },
                    400: {
                        slidesPerView: Math.min(4, maximumSlidesPerView)
                    },
                    576: {
                        slidesPerView: Math.min(5, maximumSlidesPerView)
                    },
                    768: {
                        slidesPerView: Math.min(4, maximumSlidesPerView)
                    },
                    992: {
                        slidesPerView: Math.min(5, maximumSlidesPerView)
                    },
                    1200: {
                        slidesPerView: maximumSlidesPerView
                    }
                },
                spaceBetween: 50,
                slidesPerGroup: 1
            });
        });
    }

    photoGridSlider() {
        document.querySelectorAll('.photo-grid__list').forEach(element => {
            new Swiper(element, {
                loop: true,
                speed: 1500,
                slidesPerView: 2,
                slidesPerGroup: 1,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                breakpoints: {
                    0: {
                        spaceBetween: 10,
                    },
                    768: {
                        spaceBetween: 15,
                    },
                    992: {
                        spaceBetween: 25,
                    }
                },
            });
        });
    }

    panelGridSlider() {
        document.querySelectorAll('.panel-grid__list').forEach(element => {
            new Swiper(element, {
                slidesPerView: 1,
                spaceBetween: 0,
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    992: {
                        slidesPerView: 3
                    },
                    1200: {
                        slidesPerView: 'auto'
                    }
                },
                loop: true,
                pagination: {
                    el: element.querySelector('.panel-grid__pagination'),
                    clickable: true
                }
            });
        });
    }

    bannerVideoModal() {
        document.querySelectorAll('.banner + .modal').forEach(modal => {
            const video = modal.querySelector('.banner__video');

            if (video === null) {
                return;
            }

            modal.addEventListener('shown.bs.modal', () => {
                video.play().catch(() => {});
            });

            modal.addEventListener('hidden.bs.modal', () => {
                video.pause();
                video.currentTime = 0;
            });
        });
    }

    visualBannerSlider() {
        document.querySelectorAll('.visual-slider__slider').forEach(element => {
            new Swiper(element, {
                loop: element.querySelectorAll('.swiper-slide').length > 1,
                speed: 900,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: element.querySelector('.visual-slider__pagination'),
                    clickable: true
                }
            });
        });
    }
}

window.addEventListener('load', () => new App());
